<template>
  <q-card flat class="validate-tab">
    <q-card-section class="bg-white text-white stats-wrapper">
      <div class="cards">
        <DisplayCard
          v-for="(stat, key) in stats"
          :key="key"
          :title="stat"
          :subtitle="`${capitalize(key)} articles`"
          :loading="loading"
        ></DisplayCard>
      </div>

      <q-btn color="positive" @click="renderTable++">Refresh</q-btn>
    </q-card-section>

    <q-card-section class="bg-white table-section">
      <DynamicTable :key="renderTable" @refresh-stats="getStats" />
    </q-card-section>
  </q-card>
</template>

<script>
import * as apiTo from './api'
// Components
import DisplayCard from '../../shared/DisplayCard'
import DynamicTable from './components/DynamicTable'

export default {
  components: {
    DisplayCard,
    DynamicTable
  },

  data: () => ({
    stats: null,
    loading: false,
    renderTable: 1
  }),

  methods: {
    getStats() {
      this.loading = true
      apiTo
        .getStats()
        .then(({ data }) => (this.stats = data.result))
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.validate-tab {
  padding 20px
  background #E6E6E6
  display grid
  grid-template-rows auto 1fr

  .stats-wrapper {
    display grid
    grid-template-columns 1fr auto
    align-items start

    > .cards {
      display grid
      grid-template-columns repeat(auto-fit, minmax(100px, 200px))
      justify-content center
      gap 10px
    }

    .display-card {
      background-color $tertiary
      border-radius 10px
      min-height 85px
    }
  }
  .table-section {
    padding 0 15px 15px
  }
}
</style>
